module.exports = __webpack_public_path__ + "static/media/el_trece.502d041d.jfif";